// extracted by mini-css-extract-plugin
module.exports = {"contact_banner":"about-us_contact_banner__vh_SK","jos_main_container":"about-us_jos_main_container__CvIiw"};